/* eslint-disable @typescript-eslint/no-explicit-any */

import { TrackerUserAbstract } from '../@interfaces/Tracker.interface';
import { TTrackProperties } from '../@types/Trackers.types';

import amplitude from 'amplitude-js';

class Amplitude {
  static init(): void {
    try {
      amplitude.getInstance().init(window.env.AMPLITUDE_KEY, undefined, {
        saveEvents: true,
        includeUtm: true,
        includeGclid: true,
        includeReferrer: true,
        eventUploadPeriodMillis: 1000,
        saveParamsReferrerOncePerSession: false,
      });
    } catch (e) {
      console.error(e);
    }
  }

  static identify(user?: TrackerUserAbstract): void {
    try {
      if (user && typeof user === 'object') {
        if (user?.id) amplitude.getInstance().setUserId(user.id);
        amplitude.getInstance().setUserProperties(user);
      }
    } catch (e) {
      console.error(e);
    }
  }

  static track({ eventName, properties, application }: TTrackProperties): void {
    try {
      amplitude
        .getInstance()
        .logEvent(eventName, { ...properties, application });
    } catch (e) {
      console.error(e);
    }
  }
}

const amplitudeClient = {
  init: (): void => {
    Amplitude.init();
  },
  identify: (user?: TrackerUserAbstract): void => {
    Amplitude.identify(user);
  },
  track: ({ eventName, properties, application }: TTrackProperties): void => {
    Amplitude.track({ eventName, properties, application });
  },
};

export { Amplitude, amplitudeClient };
